import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SAVE_FOOD_MOODS_MUTATION } from '../graphql/mutations'
import { transformToSaveFoodMoodsArgs } from '../graphql/transformers'
import { SAVE_FOOD_MOODS } from '../redux/action-types'

const useSaveFoodMoodsMutation = refetchLastEvent => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(store => store.foodMoods.foodMoods)

  const mutate = useCallback(
    async data => {
      await apolloService.mutate(
        SAVE_FOOD_MOODS_MUTATION,
        { data: transformToSaveFoodMoodsArgs(data) },
        dispatch,
        SAVE_FOOD_MOODS,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSaveFoodMoodsMutation
